var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHardlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5C3.725 8.5 3.5 8.725 3.5 9V15C3.5 15.275 3.725 15.5 4 15.5H14.5V8.5H4ZM2 9C2 7.89688 2.89688 7 4 7H15C15.5531 7 16 7.44687 16 8V16C16 16.5531 15.5531 17 15 17H4C2.89688 17 2 16.1031 2 15V9ZM21 8C21.5531 8 22 8.44687 22 9V15C22 15.5531 21.5531 16 21 16H17V8H21ZM19.5 9.75C19.3011 9.75 19.1103 9.82902 18.9697 9.96967C18.829 10.1103 18.75 10.3011 18.75 10.5C18.75 10.6989 18.829 10.8897 18.9697 11.0303C19.1103 11.171 19.3011 11.25 19.5 11.25C19.6989 11.25 19.8897 11.171 20.0303 11.0303C20.171 10.8897 20.25 10.6989 20.25 10.5C20.25 10.3011 20.171 10.1103 20.0303 9.96967C19.8897 9.82902 19.6989 9.75 19.5 9.75ZM18.75 13.5C18.75 13.6989 18.829 13.8897 18.9697 14.0303C19.1103 14.171 19.3011 14.25 19.5 14.25C19.6989 14.25 19.8897 14.171 20.0303 14.0303C20.171 13.8897 20.25 13.6989 20.25 13.5C20.25 13.3011 20.171 13.1103 20.0303 12.9697C19.8897 12.829 19.6989 12.75 19.5 12.75C19.3011 12.75 19.1103 12.829 18.9697 12.9697C18.829 13.1103 18.75 13.3011 18.75 13.5Z",
    fill: "#778187"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHardlock);
export default __webpack_public_path__ + "static/media/IconHardlock.eec15d8f1fab6b82e5e9d4dd3223c830.svg";
export { ForwardRef as ReactComponent };